<div class="weekly-hours-detail">
  <div class="detail-header">
    <button class="btn-back" (click)="back()">← Retour</button>
    @if (report) {
      <div class="header-info">
        <h1>{{ report.etablissementName }}</h1>
        <div class="meta">
          <span class="badge week">Semaine {{ report.weekNumber }} / {{ report.year }}</span>
          <span class="period">{{ report.weekStart | date:'dd/MM/yy' }} → {{ report.weekEnd | date:'dd/MM/yy' }}</span>
          <span class="status-pill" [class.draft]="report.status === 'DRAFT'"
            [class.ready]="report.status === 'READY'"
            [class.sent]="report.status === 'SENT'">
            {{ report.status === 'SENT' ? 'Envoyé ✓' : (report.status === 'READY' ? 'Prêt' : 'Brouillon') }}
          </span>
        </div>
      </div>
      <div class="header-actions">
        <!-- @if (!isLocked()) {
          <button class="btn btn-secondary" (click)="regenerate()" [disabled]="regenerating">
            {{ regenerating ? 'Régénération...' : 'Régénérer' }}
          </button>
        } -->
        @if (report.canSendNow) {
          <button class="btn btn-primary" (click)="send()" [disabled]="sending">
            {{ sending ? 'Envoi...' : 'Valider et envoyer' }}
          </button>
        } @else if (!isLocked()) {
          <button class="btn btn-primary" disabled
            [title]="'Disponible à partir du ' + (report.allowedSendFrom | date:'dd/MM HH:mm')">
            Envoyer (⏳)
          </button>
        }
      </div>
    }
  </div>

  @if (loading) {
    <div class="empty-state">Chargement du relevé...</div>
  } @else if (report) {
    <div class="detail-body">
      <div class="lines-pane">
        <div class="hscroll-track" #hScrollTrack
             [class.is-hidden]="!hasHorizontalOverflow"
             (pointerdown)="onTrackPointerDown($event)">
          <div class="hscroll-thumb"
               [style.width.px]="thumbWidth"
               [style.transform]="'translateX(' + thumbLeft + 'px)'"
               (pointerdown)="onThumbPointerDown($event)"></div>
        </div>
        <div class="table-scroll-container" #tableContainer (scroll)="onTableScroll()">
          <div class="lines-table">
          <div class="line-row line-head">
            <div>Réf</div>
            <div>Date début</div>
            <div>Date fin</div>
            <div>Intérimaire</div>
            <div>H. début</div>
            <div>H. fin</div>
            <div>Pause (min)</div>
            <div>Total</div>
            <div>État</div>
            <div>Observations</div>
            <div></div>
          </div>

          @if (report.lines.length === 0) {
            <div class="empty-line">Aucune ligne pour cette semaine.</div>
          }

          @for (line of report.lines; track line.id) {
            <div class="line-row line-data" [class.canceled]="line.lineState === 'ANNULE'">
              <div class="mission-cell">
                <button type="button" class="btn-mission"
                  [title]="line.missionRef || ('Mission #' + line.missionId)"
                  (click)="openMissionDetails(line)">
                  <svg-icon src="assets/icons/visible.svg"></svg-icon>
                </button>
              </div>
              <div>
                <input type="date" [(ngModel)]="line.startDate"
                  (change)="saveLine(line)"
                  [readonly]="isLocked()" />
              </div>
              <div>
                <input type="date" [(ngModel)]="line.endDate"
                  (change)="saveLine(line)"
                  [readonly]="isLocked()" />
              </div>
              <div class="candidat-cell">{{ line.candidatFullname }}</div>
              <div>
                <input type="time" [(ngModel)]="line.startTime"
                  (change)="saveLine(line)"
                  [readonly]="isLocked()" />
              </div>
              <div>
                <input type="time" [(ngModel)]="line.endTime"
                  (change)="saveLine(line)"
                  [readonly]="isLocked()" />
              </div>
              <div>
                <input type="number" min="0" max="600" [(ngModel)]="line.pauseMinutes"
                  (change)="saveLine(line)"
                  [readonly]="isLocked()" />
              </div>
              <div class="total-cell">{{ (line.totalHours ?? 0) | number:'1.2-2' }}</div>
              <div>
                <span class="state-pill"
                  [class.acheve]="line.lineState === 'ACHEVE'"
                  [class.annule]="line.lineState === 'ANNULE'"
                  [class.encours]="line.lineState === 'EN_COURS'"
                  (click)="toggleCancelLine(line)">
                  {{ line.lineState }}
                </span>
              </div>
              <div>
                <input type="text" [(ngModel)]="line.observations"
                  (blur)="saveLine(line)"
                  [readonly]="isLocked()"
                  placeholder="—" />
              </div>
              <div class="line-status">
                @if (isSaving(line)) { <span class="saving">⟳</span> }
                @else if (line.edited) { <span class="edited" title="Modifié">●</span> }
              </div>
            </div>
          }

        </div>
      </div>
      <div class="total-footer">
        <span class="total-label">TOTAL :</span>
        <span class="total-value">{{ totalHoursDisplay() }}</span>
      </div>
    </div>

      <div class="pdf-pane">
        <div class="pdf-header">
          <span>Aperçu PDF</span>
          <button class="btn-link" (click)="refreshPdf()">↻</button>
        </div>
        @if (loadingPdf) {
          <div class="pdf-loader">Chargement du PDF...</div>
        } @else if (pdfSrc) {
          <embed [src]="pdfSrc" type="application/pdf" class="pdf-embed" />
        } @else {
          <div class="pdf-loader">Aucun aperçu disponible</div>
        }
      </div>
    </div>
  }
</div>
